
<div id="page-container" class="main-content-boxed" *ngIf="isSuccess == false">
    <!-- Main Container -->
    <main id="main-container">
        <!-- Page Content -->
        <div class="bg-gd-duskx" *ngIf="model != null">

            <div class="hero-static content content-full bg-white invisibles" data-toggle="appears">
                <!-- Header -->
                <div class="py-30 px-5 text-center">

                    <h1 class="h2 font-w700 mt-50 mb-10">Reset your password</h1>
                </div>
                <!-- END Header -->
 

                <input type="hidden"  [(ngModel)]="model.Code"/>
                <div class="row justify-content-center px-5">

                    <div class="col-sm-8 col-md-6 col-xl-4"> 
 

                        <div id="divLoginWait"  *ngIf="loginStatus === 1">One moment please...</div>

                        <div style='color: brown; padding: 5px; font-weight: bold' *ngIf="loginError != ''">
                          {{error}} 
                        </div>

                        <form class="js-validation-signup"  >

                            <div class="form-group row">
                                <div class="col-12">
                                    <div class="form-material">
                                        <input type="email" class="form-control" id="signup-email" name="signup-email" [(ngModel)]="model.Email" >
                                        <label for="signup-email">Email</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-12">
                                    <div class="form-material">
                                        <input type="password" class="form-control" id="signup-password" name="signup-password" [(ngModel)]="model.Password" >
                                        <label for="signup-password">Password</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-12">
                                    <div class="form-material">
                                        <input type="password" class="form-control" id="signup-password-confirm" name="signup-password-confirm" [(ngModel)]="model.ConfirmPassword" >
                                        <label for="signup-password-confirm">Password Confirmation</label>
                                    </div>
                                </div>
                            </div>
                             
                            <div class="form-group row gutters-tiny">
                                <div class="col-12 mb-10">
                                    <button type="button" (click)="Save()" class="btn btn-block btn-hero btn-noborder btn-rounded btn-alt-success">
                                        <i class="si si-user-follow mr-10"></i> Continue
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div> 


                 


            </div>
        </div>
        <!-- END Page Content -->
    </main>
    <!-- END Main Container -->
</div> 
<!-- END Page Container -->

<app-reset-password-success *ngIf="isSuccess == true"></app-reset-password-success>



